// extracted by css-extract-rspack-plugin
export default {"list":"FYBuv","tab":"tcJXS","tabLabel":"YpmCN","panelContainer":"ei5k7","header":"eeTPU","panel":"YWxTX","dropZone":"gl5mB","isActive":"IocXK"};